import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1F2937]">
      <div className="w-full px-6 md:px-10 lg:px-14 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Product</h4>
            <div className="w-10 h-0.5 bg-[#4CAF50] mb-4" />
            <ul className="space-y-3">
              <li><a href="/#features" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Features</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=com.forcekeys.scandoc.app" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Download</a></li>
              <li><a href="/about" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">About Us</a></li>
              <li><a href="mailto:scandoc@forcekeys.com" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Support</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Company</h4>
            <div className="w-10 h-0.5 bg-[#4CAF50] mb-4" />
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">About</Link></li>
              <li><a href="mailto:scandoc@forcekeys.com" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Email</a></li>
              <li><a href="https://wa.me/2130777720574" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">WhatsApp</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Legal</h4>
            <div className="w-10 h-0.5 bg-[#4CAF50] mb-4" />
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-base mb-4">Resources</h4>
            <div className="w-10 h-0.5 bg-[#4CAF50] mb-4" />
            <ul className="space-y-3">
              <li><a href="/" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">FAQ</a></li>
              <li><a href="/" className="text-sm text-gray-400 hover:text-[#4CAF50] transition-colors">Documentation</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-[#111827]">
        <div className="w-full px-6 md:px-10 lg:px-14 py-8 md:py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/b7c5f0b009e76882be0ecef731d07359/61698ef17a874b6d66562d87f590f849.png"
              alt="ScanDoc logo"
              className="w-[60px] h-[60px] object-contain opacity-80"
            />
            <div>
              <span className="text-white font-bold text-3xl md:text-4xl tracking-tight">ScanDoc</span>
              <span className="text-gray-500 text-sm ml-2">by ForceKeys</span>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-end gap-3">
            <div className="flex items-center gap-5">
              <a href="https://x.com/forcekeys" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-[#4A90D9] transition-colors">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61584420820732" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-[#4A90D9] transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/company/forcekeys-com" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-[#4A90D9] transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://www.youtube.com/@forcekeys34200" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-[#4A90D9] transition-colors">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/hocinego2/" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center text-gray-500 hover:text-[#4A90D9] transition-colors">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
            <p className="text-gray-500 text-xs">© 2025 ForceKeys. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}